import { Inject, Injectable } from "@angular/core";
import { ConfigService } from "./config.service";
import { IDesignation } from "../models/designations";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { MailUtils } from "../utils/mail.utils";
import { SharedService } from "./shared.service";
import { DESIGNATION_SERVICE_URL } from "../models/constants";

@Injectable()
export class DesignationService {
  private baseUrl: string;
  private designationsUrl: string = "designations";

  constructor(
      @Inject(ConfigService)private config: ConfigService,
      @Inject(SharedService)private sharedService: SharedService,
      @Inject(HttpClient)private http: HttpClient
  ) {
    this.baseUrl = this.config.getConfigurationValue(DESIGNATION_SERVICE_URL);
  }

  async addDesignation(designation: IDesignation): Promise<void> {
    var accessToken = await this.sharedService.getToken();
    return new Promise<void>((resolve) => {
      const url: string = `${this.baseUrl}/api/${this.designationsUrl}`;
      this.http
        .post(url, designation, {
          headers: new HttpHeaders().set("authorization", `bearer ${accessToken}`),
        })
        .subscribe((res) => {
          console.log(JSON.stringify(res));
          resolve();
        });
    });
  }

  async getDesignations(sender: string): Promise<IDesignation[]> {
    var accessToken = await this.sharedService.getToken();
    return new Promise<IDesignation[]>((resolve) => {
      const domain: string = MailUtils.parseMultiLevelDomain(sender);
      const url: string = `${this.baseUrl}/api/${this.designationsUrl}`;

      this.http
        .get(url, {
          params: { sender, domain },
          headers: new HttpHeaders().set("authorization", `bearer ${accessToken}`),
        })
        .subscribe((res) => {
          resolve(res as IDesignation[]);
        });
    });
  }
}
